import { Polygon } from "../elements/Polygon";
import MapPropertiesService from '../../services/MapPropertiesService';

interface MultiFeaturePolygonProps {
    source: any,
    onClick?: (feature: any, latLng: any) => void,
}
export const MultiFeaturePolygon = ({
    source,
    onClick
}: MultiFeaturePolygonProps) => {
    const mapProperties = MapPropertiesService.properties;
    return (
        <Polygon
            paths={source.paths}
            fillColor={mapProperties.ColorMulti}
            strokeWeight={0}
            strokeColor={"transparent"}
            onClick={handleOnClick}
        />
    );

    function handleOnClick(e: any) {
        if (!onClick) return;
        onClick(source, e.latLng);
    }
}

